import { Action } from "@ngrx/store";
import { Member, Role } from "./members.reducer";

export enum MembersActionTypes {
  SetMembers = "[Members] Set Members",
  RemoveMember = "[Members] Remove Member",
  AddMember = "[Members] Add Member",
  SetRoles = "[Members] Set Roles",
}

export class SetMembers implements Action {
  readonly type = MembersActionTypes.SetMembers;
  constructor(public members: Member[]) {}
}

export class AddMember implements Action {
  readonly type = MembersActionTypes.AddMember;
  constructor(public member: Member) {}
}

export class RemoveMember implements Action {
  readonly type = MembersActionTypes.RemoveMember;
  constructor(public memberID: string) {}
}

export class SetRoles implements Action {
  readonly type = MembersActionTypes.SetRoles;
  constructor(public roles: Role[]) {}
}

export type MembersActions = SetMembers | SetRoles | AddMember | RemoveMember;
